<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
   <handle/>
		<div class="container">
			<div class="tabs">
				<div class="circle"></div>
				<div class="item text-bold">
					<router-link :to="{path:'/company',query:{menuPosition:'1503537762663464961'}}" tag="a">
						{{serviceTypeList[0]}}
					</router-link>
				</div>
				<div class="circle"></div>
				<div class="item text-bold">
					<router-link :to="{path:'/member',query:{menuPosition:'1482177348570787842'}}" tag="a">
						{{serviceTypeList[1]}}
					</router-link>
				</div>
				<div class="circle circle-active"></div>
				<div class="item active text-bold">
					<router-link :to="{path:'/financing',query:{menuPosition:'1492378541355991041'}}" tag="a">
						{{serviceTypeList[2]}}
					</router-link>
				</div>
				<div class="circle circle-active"></div>
			</div>

			<!-- card -->
			<div class="card" v-for="(item,index) in serviceList">
				<div class="card-head flex align-center">
					<div class="line"></div>
					<div class="margin-left-5 font-24 color-1a">{{item.serviceTypeName}}</div>
				</div>
				<div class="card-body flex justify-between" v-if="item.serviceCategoryList!=null">
					<div v-for="(child,childIndex) in item.serviceCategoryList" class="item"
						:style="`background: url(${$api.baseUrl+$api.imgPath+child.backgroundUrl}) no-repeat;backgroundSize:100% 100%;`">
						<a :href="child.linkUrl" target="_blank" v-if="child.linkUrl!=null && child.linkUrl!=''">
							<div class="contents">
								<div class="title"><span>{{child.serviceCategory}}</span></div>
								<div class="desc">{{child.serviceCategoryContent}}</div>
							</div>
						</a>
						<router-link :to="'/financing/serviceInfo/'+child.id" v-if="child.linkUrl==null || child.linkUrl==''">
							<div class="contents">
								<div class="title"><span>{{child.serviceCategory}}</span></div>
								<div class="desc">{{child.serviceCategoryContent}}</div>
							</div>
						</router-link>
					</div>
				</div>
				<div class="flex justify-center" v-if="item.serviceCategoryList==''">
					<div class="padding-top-15">
						<a-empty style="padding:50px;" description="暂无数据" />
					</div>
				</div>
			</div>

			<div class="card">
				<img width="100%" class="bg_img" src="@/assets/fi_bg.png" alt="">
				<div class="login_bg">
					<div class="login-card">
						<div class="title">登录可查看所有数据</div>
						<div><a href="https://biz.hebotc.com/index.html#/login" target="_blank" class="login_btn">去登录</a></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import handle from "@/components/handle"
	export default {
		components: {
      handle
    },
		data() {
			return {
				headBg: require("../../assets/finance_bg.png"),
				itemBg: require("../../assets/service_item_bg.png"),
				serviceTypeId: "1495315253954670594",
				serviceList: [],
				serviceTypeList: [],
				loading: true,
				menuPosition: "1492378541355991041",
			}
		},
		mounted() {
			document.title = "河北股权交易所-融资服务";
			// this.menuPosition = this.$route.query.menuPosition;
			this.getHeadBanner();
			this.getServiceTypeList();
			this.getServiceList();
		},
		methods: {
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: 7,
						type: 1

					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			getServiceTypeList() {
				this.$request({
					url: this.$api.service.getServiceTypeList
				}).then((res) => {
					let _list = res.data.result;
					this.serviceTypeList = [];
					_list.forEach((item) => {
						this.serviceTypeList.push(item.serviceType);
					})
				})
			},
			getServiceList() {
				this.$request({
					url: this.$api.service.getServiceList,
					data: {
						serviceTypeId: this.serviceTypeId
					},
				}).then((res) => {
					this.serviceList = res.data.result;
					this.loading = false;
				})
			},
		}
	}
</script>

<style scoped="scoped">
	.bg_img{
		position: relative;
		width: 1160px;
		height: 559px;
	}

	.login_bg{
		width: 1160px;
		height: 559px;
		position: absolute;
		top:20px;
		background-color: rgba(0,0, 0,0.8);
		border-radius: 8px;
		backdrop-filter:blur(5px);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.login-card{
		width: 400px;
		height: 200px;
		background-color: white;
		border-radius: 4px;
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
	}

	.login-card .title{
		font-size: 20px;
		font-weight: bold;
	}

	.login_btn{
		width: 240px;
		height: 40px;
		background-color:#13B8EE;
		display: block;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		border-radius: 8px;
		margin-top: 40px;
	}

	.tabs {
		width: 100%;
		height: 80px;
		border-radius: 8px;
		background-color: white;
		display: flex;
		font-size: 18px;
		padding-left: 50px;
		padding-right: 50px;
		align-items: center;
		justify-content: space-between;
		margin-top: -50px;
	}

	.tabs .item {
		font-size: 24px;
		letter-spacing: 4px;
	}


	.tabs .item a {
		color: #666;
	}

	.tabs .active a {
		color: #13B8EE;
	}

	.tabs .item:hover a {
		color: #13B8EE;
	}

	.tabs .circle {
		width: 8px;
		height: 8px;
		background: #E6E6E6;
		border-radius: 50%;
		opacity: 1;
	}

	.tabs .circle-active {
		width: 8px;
		height: 8px;
		background: #13B8EE;
		border-radius: 50%;
		opacity: 1;
	}

	.line {
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.card {
		position: relative;
		margin-top: 15px;
		padding: 20px;
		border-radius: 8px;
		background-color: white;
		margin-bottom: 20px;
	}

	.card .card-body {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
	}

	.card .card-body .item {
		width: 49%;
		height: 300px;
		margin-top: 24px;
		border-radius: 8px;
	}

	.card .card-body .item .contents {
		width: 100%;
		height: 100%;
		border-radius: 8px;
		padding: 40px;
		background-color: rgba(28, 44, 129, 0.5);
	}

	.card .card-body .item .contents .title {
		font-size: 22px;
		color: white;
		margin-top: 180px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.5);
		padding-bottom: 10px;
		transition: all 0.3s;
	}

	.card .card-body .item .contents .title span {
		border-bottom: 1px solid white;
		padding-bottom: 15px;
	}

	.card .card-body .item .contents .desc {
		display: none;
		color: white;
		transition: all 0.3s;
		font-size: 16px;
		margin-top: 15px;
	}

	.card .card-body .item .contents:hover {
		background: linear-gradient(180deg, rgba(30, 34, 172, 0.7) 0%, rgba(12, 178, 236, 0.7) 100%);
	}

	.card .card-body .item .contents:hover .desc {
		display: block;
		margin-bottom: 57px;
	}

	.card .card-body .item .contents:hover .title {
		margin-top: 120px;
	}

	body {
		background-color: #F6F7FC;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/financing/service.vue